/**
 * COMPONENTE WEATHER WIDGET
 * =========================
 * Widget de clima para el sidebar
 */

import React from 'react';
import { Card, CardContent } from '../../ui/card';
import { Sun, Cloud, CloudRain, Droplets, Wind } from 'lucide-react';

const getWeatherIcon = (condition) => {
    switch (condition.toLowerCase()) {
        case 'soleado':
            return <Sun className="w-6 h-6 text-yellow-500" />;
        case 'nublado':
        case 'parcialmente nublado':
            return <Cloud className="w-6 h-6 text-gray-500" />;
        case 'lluvia':
            return <CloudRain className="w-6 h-6 text-blue-500" />;
        default:
            return <Sun className="w-6 h-6 text-yellow-500" />;
    }
};

const WeatherWidget = ({ weatherData }) => {
    if (!weatherData) return null;

    return (
        <Card className="border-0 shadow-lg bg-gradient-to-br from-blue-50 to-cyan-50">
            <CardContent className="p-6">
                <h3 className="text-xl text-center font-bold text-gray-900 mb-4">Clima en {weatherData.location}</h3>

                <div className="text-center mb-6">
                    <div className="flex items-center justify-center mb-2">
                        {weatherData.current.iconUrl ? (
                            <img
                                src={weatherData.current.iconUrl}
                                alt={weatherData.current.condition}
                                className="w-16 h-16 object-contain"
                            />
                        ) : (
                            getWeatherIcon(weatherData.current.condition)
                        )}
                    </div>
                    <div className="text-5xl font-bold text-gray-900 mb-1">{weatherData.current.temp}°</div>
                    <p className="text-sm text-gray-700">{weatherData.current.condition}</p>
                    <div className="flex items-center justify-center space-x-4 mt-3 text-sm text-gray-600">
                        <div className="flex items-center space-x-1">
                            <Droplets className="w-4 h-4" />
                            <span>{weatherData.current.humidity}%</span>
                        </div>
                        <div className="flex items-center space-x-1">
                            <Wind className="w-4 h-4" />
                            <span>{weatherData.current.wind} km/h</span>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-3 gap-2">
                    {weatherData.forecast.slice(0, 3).map((day, index) => (
                        <div key={index} className="bg-white/60 backdrop-blur-sm rounded-xl p-3 text-center">
                            <div className="text-xs font-medium text-gray-700 mb-1">{day.day}</div>
                            <div className="flex justify-center mb-1">
                                <div className="scale-75">
                                    {day.iconUrl ? (
                                        <img
                                            src={day.iconUrl}
                                            alt={day.condition}
                                            className="w-12 h-12 object-contain"
                                        />
                                    ) : (
                                        getWeatherIcon(day.condition)
                                    )}
                                </div>
                            </div>
                            <div className="text-sm font-semibold text-gray-900">{day.high}°</div>
                            <div className="text-xs text-gray-600">{day.low}°</div>
                        </div>
                    ))}
                </div>
            </CardContent>
        </Card>
    );
};

export default WeatherWidget;
